<template>
  <div class="cta-container" v-if="allCallToActions.length > 0">
    <div class="cta-card">
      <div class="cta-tag">
        <v-icon left color="white">mdi-alert</v-icon>
        <span>ALERTS</span>
      </div>
      <div class="cta-message">
        <div class="scrolling-message">
          {{allCallToActions[count].description}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CallToAction',
    data() {
      return {
        count: -1,
        direction: true
      }
    },
    created() {
      this.$store.dispatch('get_all_call_to_actions')
      setTimeout(this.callToAction(), 1000)
    },
    methods: {
      callToAction: function () {
        var length = this.allCallToActions.length
        if (this.count < length && this.direction === true) {
          this.count = this.count + 1
        } else if (this.count < length && this.direction === true) {
          this.count = this.count - 1
        }
      }
    }
  }
</script>

<style scoped>
  .cta-container {
    padding: 10px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }

  .cta-card {
    display: flex;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0,0,0,0.15);
    background: linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.1)), url('https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80');
    background-size: cover;
    background-position: center;
    color: white;
    height: 60px;
    border-left: 4px solid #74a533;
  }

  .cta-tag {
    display: flex;
    align-items: center;
    background: linear-gradient(135deg, #74a533 0%, #4a7a1a 100%);
    padding: 0 15px;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px;
    letter-spacing: 1px;
    position: relative;
  }

    .cta-tag::after {
      content: '';
      position: absolute;
      right: -10px;
      top: 0;
      width: 0;
      height: 0;
      border-top: 30px solid transparent;
      border-bottom: 30px solid transparent;
      border-left: 10px solid #4a7a1a;
    }

  .cta-message {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 20px;
    background-color: rgba(0,0,0,0.4);
    backdrop-filter: blur(3px);
  }

  .scrolling-message {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    font-size: 16px;
    font-weight: 500;
    animation: scrollText 60s linear infinite;
    text-shadow: 0 1px 3px rgba(0,0,0,0.5);
  }

  @keyframes scrollText {
    0% {
      transform: translateX(100%);
    }

    100% {
      transform: translateX(-100%);
    }
  }

  @keyframes fadePulse {
    0% {
      opacity: 0.8;
    }

    50% {
      opacity: 1;
      text-shadow: 0 0 8px rgba(116, 165, 51, 0.7);
    }

    100% {
      opacity: 0.8;
    }
  }

  .v-icon {
    animation: fadePulse 2s infinite;
  }
</style>
